import React from 'react';
import styles from './ScrollHint.module.scss';

export const ScrollHint = (props) => {
    return (
        <div className={styles.scroll}><span></span><span></span><span></span></div>
    )
}